"use client";
import * as React from "react";
const SvgWarningRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 15", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M1.68 14.135h12.64c1.293 0 2.099-1.402 1.452-2.518L9.452.697a1.678 1.678 0 0 0-2.904 0l-6.32 10.92c-.647 1.116.16 2.518 1.452 2.518zM8 8.26a.842.842 0 0 1-.84-.84V5.742c0-.462.378-.84.84-.84.462 0 .84.378.84.84V7.42c0 .462-.378.84-.84.84zm.84 3.357H7.16V9.938h1.68v1.679z" }));
export {
  SvgWarningRound as default
};
